/*
 * @Description: 页面名称
 * @Autor: kangcheng
 * @Date: 2024-01-04 13:56:44
 * @LastEditors: kangcheng
 * @LastEditTime: 2024-01-08 10:28:05
 */
import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import store from '../store';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function (location) {
  return originalPush.call(this, location).catch((err) => { });
};

//import "vant/lib/index.css"
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/translate/voice-translation",
  },
  {
    path: "/translate/text-translation",
    name: "textTranslation",
    component: () => import("../views/translate/text-translation.vue"),
  },
  {
    path: "/translate/voice-translation",
    name: "voiceTranslation",
    component: () => import("../views/translate/voice-translation/index.vue"),
  },

  // --公共二级列表
  {
    path: "/common/secondary-list",
    name: "secondary-list",
    component: () => import("../views/common/secondary-list.vue"),
  },
  // --公共二级列表-更多页面
  {
    path: "/common/common-list",
    name: "common-list",
    component: () => import("../views/common/common-list.vue"),
  },
  //汇率列表
  {
    path: "/exchange/index",
    name: "exchange",
    component: () => import("../views/exchange/index.vue"),
  },
  //汇率查询
  {
    path: "/exchange/search",
    name: "search",
    component: () => import("../views/exchange/search.vue"),
  },
  //资讯
  {
    path: "/common/information",
    name: "information",
    component: () => import("../views/common/information.vue"),
  },
  //无内容页
  {
    path: "/common/no-page",
    name: "noPage",
    component: () => import("../views/common/no-page.vue"),
  },
  // 免签查询-单独  
  {
    path: "/visa/inquiry",
    name: "inquiry",
    component: () => import("../views/visa/inquiry.vue"),
  },
  // 新增 --2024 11-12-- 护照免签
  {
    path: "/common/passport-visa-free",
    name: "inquiry",
    component: () => import("../views/common/passport-visa-free.vue"),
  },
  // 签证
  {
    path: "/visa/index",
    name: "visa",
    component: () => import("../views/visa/index.vue"),
  },
  // 多栏目更多
  {
    path: "/common/common-more",
    name: "common-more",
    component: () => import("../views/common/common-more.vue"),
  },
  // 签证到期提醒
  {
    path: "/visa/expire",
    name: "visa",
    component: () => import("../views/visa/expire.vue"),
  },
  // 签证须知  
  {
    path: "/visa/notice",
    name: "notice",
    component: () => import("../views/visa/notice.vue"),
  },

  // 联系使馆
  {
    path: "/visa/embassy",
    name: "embassy",
    component: () => import("../views/visa/embassy.vue"),
  },
  // 居留
  {
    path: "/reside/index",
    name: "reside",
    component: () => import("../views/reside/index.vue"),
  },

  // 移民服务
  {
    path: "/reside/migrate-service",
    name: "migrate-service",
    component: () => import("../views/reside/migrate-service.vue"),
  },

  // 居留-服务指南
  {
    path: "/reside/guide",
    name: "guide",
    component: () => import("../views/reside/guide.vue"),
  },
  /// 就业认证
  {
    path: "/reside/employment",
    name: "employment",
    component: () => import("../views/reside/employment.vue"),
  },
  // 投资商贸 与 来华留学 页面一样 共用
  {
    path: "/reside/commerce",
    name: "commerce",
    component: () => import("../views/reside/commerce.vue"),
  },
  // 住宿||医疗护理 ||子女入学
  {
    path: "/reside/stay",
    name: "stay",
    component: () => import("../views/reside/commerce.vue"),
  },
  // 通关
  {
    path: "/clearance/index",
    name: "clearance",
    component: () => import("../views/clearance/index.vue"),
  },
  // 便民生活  ||电影演出
  {
    path: "/convenient/index",
    name: "convenient",
    component: () => import("../views/convenient/index.vue"),
  },
  // 法律服务
  {
    path: "/convenient/legal-service",
    name: "legalService",
    component: () => import("../views/convenient/legal-service.vue"),
  },
  // 餐饮美食
  {
    path: "/convenient/restaurant",
    name: "restaurant",
    component: () => import("../views/convenient/restaurant.vue"),
  },
  // 生活购物
  {
    path: "/convenient/life-shopping",
    name: "lifeShopping",
    component: () => import("../views/convenient/life-shopping.vue"),
  },
  // 汉语学习
  {
    path: "/convenient/chinese-learning",
    name: "chineseLearning",
    component: () => import("../views/convenient/chinese-learning.vue"),
  },
  // 交通出行
  {
    path: "/convenient/travel",
    name: "travel",
    component: () => import("../views/convenient/travel.vue"),
  },
  // 金融服务
  {
    path: "/convenient/finance",
    name: "finance",
    component: () => import("../views/convenient/finance.vue"),
  },
  // 休闲娱乐
  {
    path: "/leisure/index",
    name: "leisure",
    component: () => import("../views/leisure/index.vue"),
  },
  // 了解中国
  {
    path: "/introduction-china/index",
    name: "introduction-china",
    component: () => import("../views/introduction-china/index.vue"),
  },
  // 了解中国
  {
    path: "/common/common-video",
    name: "common-video",
    component: () => import("../views/common/common-video.vue"),
  },
  // 体验官
  {
    path: "/introduction-china/experience",
    name: "experience",
    component: () => import("../views/introduction-china/experience.vue"),
  },
  // 我的 意见反馈
  {
    path: "/feedback/index",
    name: "feedback",
    component: () => import("../views/feedback/index.vue"),
  },
  // 反馈建议列表
  {
    path: "/feedback/feed-list",
    name: "feedList",
    component: () => import("../views/feedback/feed-list.vue"),
  },
  // 反馈投拆记录
  {
    path: "/feedback/record",
    name: "record",
    component: () => import("../views/feedback/record.vue"),
  },
  // 反馈详情
  {
    path: "/feedback/feed-detail",
    name: "feedDetail",
    component: () => import("../views/feedback/feed-detail.vue"),
  },
  // 功能异常
  {
    path: "/feedback/dysfunction",
    name: "dysfunction",
    component: () => import("../views/feedback/dysfunction.vue"),
  },
  // 急救包
  {
    path: "/first-aid/index",
    name: "firstAid",
    component: () => import("../views/first-aid/index.vue"),
  },
  // 二十四节气 列表 
  {
    path: "/solar-terms/index",
    name: "solarTerms",
    component: () => import("../views/solar-terms/index.vue"),
  },
  // 下载
  {
    path: "/common/dowload",
    name: "dowload",
    component: () => import("../views/common/dowload.vue"),
  },
  {
    path: "/home",
    name: "Home",
    component: Home,
    meta: {
      isShow: true,
    },
    children: [
      {
        path: "product",
        name: "product",
        component: () =>
          import(/* webpackChunkName: "Brand" */ "../views/product.vue"),
      },
      {
        path: "homeComponents",
        name: "HomeComponents",
        meta: {
          isShow: true,
        },
        component: () =>
          import(/* webpackChunkName: "Brand" */ "../views/homeComponents.vue"),
      },
    ],
  },
];

const router = new VueRouter({
  // mode: "hash",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  console.log(from.name, 111);
  store.state.common.arr.push(from.name)
  console.log(store.state.common.arr, 'arr');
  // console.log(store.state.common.languageAll, 'ddssff');
  // if (!store.state.common.languageAll) {
  //   console.log(1122233);
  //   store.dispatch("common/setLanguage").then(res => {
  //     console.log(11);
  //     next();
  //   });
  //   // store.dispatch('fetchData').then(() => {
  //   //   next(); // 数据加载完成后导航到目标路由  
  //   // });
  // }
  if (to.path == "/cart") {
    let token = localStorage.getItem("token");
    if (token) {
      next();
    } else {
      next("/user");
      Vue.prototype.$toast("请先登陆");
      // setTimeout(() => {
      // 	next("/user")
      // }, 500)
    }
  }
  next();
});
export default router;
